<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint
      v-if="!isIndividualOrganizationSubject && !isFizOrganizationSubject"
      value="Наименование организации, от имени которой подается заявка"
    />
    <div v-if="form.organization.innError" class="form-fielderror">
      <label>!</label>
      <div class="form-fielderror-text">
        <div>{{ form.organization.innHint }}</div>
      </div>
    </div>
    <label for="form-organization-name" class="control-label">{{ organizationNameInputLabel }}</label>
    <input
      type="text"
      class="form-control"
      id="form-organization-name"
      placeholder="Введите наименование или ИНН организации"
      autocomplete="off"
      :disabled="disabled"
      v-model="inputValue"
      @change="emit"
      @input="emit"
      @blur="emit"
      @keyup.enter="emit"
      @keyup.delete="emit"
    />
    <typeahead
      :async-function="typeahead"
      :item-key="typeaheadItemKey"
      :limit="typeaheadLimit"
      target="#form-organization-name"
      v-model="inputValue"
      @input="selectTypeahead"
    >
      <template v-slot:item="props">
        <li
          v-for="(item, index) in props.items"
          :class="{ active: props.activeIndex === index }"
          v-bind:key="index"
        >
          <a role="button" @click="props.select(item)">
            <div v-html="props.highlight(item)"></div>
            <template v-if="!isFizOrganizationSubject && item">
              <div>{{ item.inn }}</div>
              <div v-if="item.address">{{ item.address }}</div>
            </template>
          </a>
        </li>
      </template>
    </typeahead>
    <template v-if="canShowFindOnlyInRegionCheckbox">
      <label class="applicant-helpers flex-label">
        <input type="checkbox"
               id="checkbox"
               :value="checkboxValue"
               :disabled="disabled"
               @change="emit($event, 'switch-location-name')"
        />
        &nbsp;
        {{ checkboxLabel }}
      </label>
    </template>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import organizationSectionMixin from '../../../../mixins/application-form/organizationSectionMixin'
import organizationInputMixin from '../../../../mixins/application-form/organizationInputMixin'
import mainMixin from '@/common/mixins/mainMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'OrganizationNameInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    organizationSectionMixin,
    organizationInputMixin,
    mainMixin
  ],

  props: {
    inputName: {
      default: 'name'
    },

    nationalitiesList: {
      default: []
    },

    locationName: {
      type: String,
      default: 'all'
    }
  },

  computed: {
    checkboxValue () {
      return this.configuration?.find_region ?? 'nw'
    },

    checkboxLabel () {
      return this.configuration?.text_checkbox_find ?? 'Искать только в Северо-Западном ФО'
    },

    organizationNameInputLabel () {
      if (this.inputLabel) {
        return this.inputLabel
      }

      return this.isEntityOrganizationSubject
        ? 'Наименование организации'
        : 'Фамилия, имя, отчество'
    },

    canShowFindOnlyInRegionCheckbox() {
      return !this.isView && !this.isFizOrganizationSubject && !this.isTerminalSubject && !this.isForeignSubject && this.isOrganizationResidencyRus
    }
  }
}
</script>
